export default __webpack_public_path__ + "static/meet-john-7-962b74c7a28ddc18f3dbc33f87c73451.webp";